// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabEmailsCreateEmailModeField-modulemodeFieldInput__jsZgI";
var _2 = "RequestProfileTabEmailsCreateEmailModeField-modulemodeFieldLabel__nyL1v";
export { _1 as "modeFieldInput", _2 as "modeFieldLabel" }
